// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__3rNlZ","gradient":"styles_gradient__CQZAw"};